export default __webpack_public_path__ + "static/fondoModalKeys-eb93a818085dc9f8c7ae35a45f34b1aa.png";